<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.61778 2.76899C7.77886 2.48842 9.98225 2.34375 12.219 2.34375C14.4556 2.34375 16.6588 2.48839 18.8197 2.76891C20.822 3.02885 22.2483 4.70768 22.367 6.65098C22.0276 6.53765 21.6679 6.46246 21.2917 6.43124C19.8453 6.31118 18.3826 6.25 16.9062 6.25C15.4298 6.25 13.9672 6.31118 12.5208 6.43123C10.0643 6.63512 8.3125 8.71319 8.3125 11.0502V15.5143C8.3125 17.2754 9.30696 18.8882 10.8467 19.6644L8.08368 22.4274C7.86024 22.6509 7.52421 22.7177 7.23228 22.5968C6.94035 22.4759 6.75 22.191 6.75 21.875V17.6776C6.37135 17.6371 5.99393 17.5924 5.61779 17.5435C3.52569 17.2719 2.0625 15.4514 2.0625 13.3986V6.91394C2.0625 4.86117 3.52568 3.04061 5.61778 2.76899Z" 
            :fill="color"
        />
            <path d="M16.9062 7.8125C15.473 7.8125 14.0535 7.87189 12.6501 7.98838C11.0466 8.12146 9.875 9.4821 9.875 11.0502V15.5143C9.875 17.0848 11.05 18.4462 12.6554 18.5772C13.9511 18.683 15.2605 18.7408 16.5816 18.749L19.4788 21.6462C19.7023 21.8696 20.0383 21.9365 20.3302 21.8155C20.6222 21.6946 20.8125 21.4097 20.8125 21.0937V18.6043C20.9274 18.5957 21.0423 18.5867 21.157 18.5773C22.7625 18.4463 23.9375 17.0849 23.9375 15.5144V11.0502C23.9375 9.48211 22.7659 8.12147 21.1625 7.98838C19.759 7.87189 18.3394 7.8125 16.9062 7.8125Z" 
            :fill="color"
        />
        </svg>

    </div>
</template>

<script>
export default {
    name: 'IconSvgMessages',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>